import TemplateData from '../../utility/getTemplateData';
import fonts from '../../styles/fonts';
import {
	formatCurrency,
	normalizeNumber
} from '../../utility/formator';

export const MIN_INPUT_WIDTH = 105;
const DEFAULT_INPUT_FONTSIZE = 55;


export function formatAmount(value, currency) {
	value = value.replace(/[^0-9]/g, '') || 0;
	value = parseInt(value, 10).toString();

	if (value.length === 1) {
		value = `00${value}`;
	} else if (value.length === 2) {
		value = `0${value}`;
	}

	value = `${value.slice(0, -2)}.${value.slice(-2)}`;
	return formatCurrency({ value, currency });
}

export function amountLengthValid(value) {
	const val = value.replace(/[^0-9]/g, '') || 0;

	if (val.length > 9) {
		return false;
	}
	return true;
}

const allowedKeys = [16, 46, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57];
export function isKeyAllowed(keyCode) {
	return allowedKeys.indexOf(keyCode) > -1;
}

export function getMinimumDonationErrorMessage(messages) {
	return TemplateData.enablePresetAmounts ?
		messages.error.minimumDonationUSShort :
		messages.error.minimumDonationUS;
}


export function isAmountGreaterThanZero(amount) {
	const normalizedDonationAmount = getNormalizedNumber(amount);
	return normalizedDonationAmount > 0;
}

/**
 * Returns griffin-normalized number or zero
 */
function getNormalizedNumber(amount) {
	try {
		if (!amount) {
			return 0;
		}

		const normalizedNumber = normalizeNumber(amount);

		if (typeof normalizedNumber !== 'number' && normalizedNumber.errors) {
			return 0;
		}

		return normalizedNumber;
	} catch (e) {
		return 0;
	}
}

/**
 * Gets the width of the input field
 * @param  {HTMLElement} input The input element
 * @param  {String} text Value of the input element
 * @return {Number}      Width of the input element
 */
export function getInputWidth(field, text) {
	text = text || '0.00';

	// Get styles from the element
	const currentStyles = window.getComputedStyle(field) || {};
	let {
		fontSize = DEFAULT_INPUT_FONTSIZE,
		fontWeight
	} = currentStyles;
	fontSize = typeof fontSize === 'number' ? `${fontSize}px` : fontSize;

	// Create a span element outside visible area
	const spanElem = document.createElement('span');
	spanElem.style.fontSize = fontSize;
	spanElem.style.fontFamily = fonts.ppSansBigLight;
	spanElem.style.fontWeight = fontWeight || '200';
	spanElem.style.position = 'fixed';
	spanElem.style.top = '-1000px';
	spanElem.style.left = '-1000px';
	spanElem.innerHTML = text;
	document.body.appendChild(spanElem);

	// Get width of the span and then remove it
	const width = spanElem.getBoundingClientRect().width;
	document.body.removeChild(spanElem);

	if (width < MIN_INPUT_WIDTH) {
		return MIN_INPUT_WIDTH;
	}
	return width;
}




// WEBPACK FOOTER //
// ./components/amount/amountUtils.js